module.exports = __webpack_public_path__ + "static/cta-9c1881203e78ee2eda91835a8a2bf8e1.svg";